import { useState } from 'react';
import { downloadPlatforms } from '@/mocks/home';

export default function DownloadSection() {
  const [active, setActive] = useState(downloadPlatforms[0].id);
  const current = downloadPlatforms.find((p) => p.id === active) ?? downloadPlatforms[0];

  return (
    <section id="download" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-700">
            Download
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            App 下载方式（按设备查看）
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            选择你正在使用的设备，查看对应的获取与安装说明。无论哪种设备，
            都应优先选择官方发布来源。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-6">
          <div className="flex flex-col gap-2 rounded-lg border border-background-200 bg-background-50 p-2 lg:h-fit">
            {downloadPlatforms.map((p) => (
              <button
                key={p.id}
                type="button"
                onClick={() => setActive(p.id)}
                className={`flex items-center gap-3 rounded-md px-3.5 py-3 text-left transition-colors cursor-pointer ${
                  active === p.id
                    ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                    : 'text-foreground-800 hover:bg-secondary-100'
                }`}
              >
                <i className={`${p.icon} text-xl`}></i>
                <span className="text-sm font-medium whitespace-nowrap">{p.name}</span>
              </button>
            ))}
            <div className="mt-1 rounded-md bg-secondary-50 p-3.5">
              <p className="text-xs leading-relaxed text-secondary-800">
                提示：不同设备的获取方式会随上架状态调整，请以官方页面实际展示为准。
              </p>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
            <div className="flex items-center gap-3">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${current.icon} text-2xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                  {current.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600">获取与安装说明</p>
              </div>
            </div>

            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-700">
              {current.summary}
            </p>

            <ol className="mt-6 space-y-4">
              {current.steps.map((s, i) => (
                <li key={s} className="flex items-start gap-3">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                    {i + 1}
                  </span>
                  <span className="pt-0.5 text-sm md:text-base leading-relaxed text-foreground-800">
                    {s}
                  </span>
                </li>
              ))}
            </ol>

            <div className="mt-6 flex items-start gap-2.5 rounded-md border border-accent-200 bg-accent-50 p-4">
              <i className="ri-alert-line mt-0.5 text-accent-700"></i>
              <p className="text-xs md:text-sm leading-relaxed text-foreground-700">
                {current.note}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}